import { ExecuteButton,BackSpace } from "../../SVG";

export const numdata = [
    {
        style:{left:'80px',top:'240px'},
        val:'0',
        operator:false
    },

    {
        style:{left:'0px',top:'160px'},
        val:'1',
        operator:false,
    },

    {
        style:{left:'80px',top:'160px'},
        val:'2',
        operator:false
    },

    {
        style:{left:'160px',top:'160px'},
        val:'3',
        operator:false,
    },

    {
        style:{left:'0px',top:'80px'},
        val:'4',
        operator:false,
    },

    {
        style:{left:'80px',top:'80px'},
        val:'5',
        operator:false,
    },

    {
        style:{left:'160px',top:'80px'},
        val:'6',
        operator:false,
    },

    {
        style:{left:'0px'},
        val:'7',
        operator:false,
    },

    {
        style:{left:'80px'},
        val:'8',
        operator:false,
    },

    {
        style:{left:'160px'},
        val:'9',
        operator:false,
    },

    {
        style:{left:'160px',top:'240px'},
        val:'',
        svg:BackSpace(),
        operator:false,
    },

    {
        style:{left:'0px',top:'240px'},
        val:'.',
        operator:false,
    },
]